import { render, staticRenderFns } from "./Top5.vue?vue&type=template&id=1ad6a49c&"
import script from "./Top5.vue?vue&type=script&lang=js&"
export * from "./Top5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports